const BDS_CHIP_EXPANDABLE_STYLE_ID = 'bds-chip-expandable-styles';

const BDS_CHIP_EXPANDABLE_STYLES = `
  .chip_clickable {
    height: fit-content !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }
  .chip_clickable--text {
    height: auto !important;
    white-space: normal !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    min-width: 0 !important;
  }
`;

export const applyBdsChipExpandableStyles = (chip: HTMLElement): void => {
  const shadowRoot = chip.shadowRoot;
  if (!shadowRoot || shadowRoot.querySelector(`#${BDS_CHIP_EXPANDABLE_STYLE_ID}`)) return;

  const style = document.createElement('style');
  style.id = BDS_CHIP_EXPANDABLE_STYLE_ID;
  style.textContent = BDS_CHIP_EXPANDABLE_STYLES;
  shadowRoot.appendChild(style);
};
